import {
  CarrierStatus,
  type CarrierDocumentsStatusType,
  type CarrierStatusType,
  CarrierDocumentsStatus,
} from 'auth/domain/Carrier'

export const enum OnboardingStep {
  Pending = 'pending',
  UnderReview = 'under-review',
}

export function getOnboardingStep(
  carrierStatus: CarrierStatusType,
  documentsStatus: CarrierDocumentsStatusType
): OnboardingStep {
  if (
    carrierStatus === CarrierStatus.Pending &&
    documentsStatus === CarrierDocumentsStatus.UnderReview
  )
    return OnboardingStep.UnderReview
  return OnboardingStep.Pending
}

export function isOnboardingRequired(carrierStatus?: CarrierStatusType): boolean {
  return carrierStatus !== CarrierStatus.Ready
}
